import * as React from 'react';

import type { Logger } from '@feature-hub/core';
import type { BffLoggerCall } from '@visualizer/bff';

import { useSafeContext } from './use-safe-context';

export type Logging = {
	readonly logger: Logger;
};

export const LoggingContext = React.createContext<Logging | undefined>(undefined);

export function useLogger(): Logger {
	return useSafeContext(LoggingContext, 'LoggingContext').logger;
}

export type LoggingProviderProps = React.PropsWithChildren<{ logger: Logger }>;

export function LoggingProvider({ logger, children }: LoggingProviderProps): React.ReactElement {
	return <LoggingContext.Provider value={{ logger }}>{children}</LoggingContext.Provider>;
}

export function logBffLoggerCalls(bffLoggerCalls: BffLoggerCall[], logger: Logger): void {
	for (const call of bffLoggerCalls) {
		logger.debug(logPrefixes[call.level], ...call.args);
	}
}

const logPrefixes: Readonly<Record<BffLoggerCall['level'], string>> = {
	error: 'BFF Error:',
	warn: 'BFF Warning:'
};
